export default "__VITE_ASSET__ySkYUwGt__"